// Meta Pixel event tracking.
// The base pixel (init + PageView) is loaded once in public/index.html.
// This module only fires additional conversion events on top of it —
// it must never re-add the base <script> or create a second pixel.

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

const PIXEL_ID = "2271698603583701";

export interface LeadAdvancedMatching {
  email?: string;
  phone?: string;
  city?: string;
}

export const metaPixel = {
  /**
   * Fire the Lead conversion event. Call this only once, after the backend
   * has confirmed the submission was saved.
   */
  trackLead(advancedMatching?: LeadAdvancedMatching) {
    if (typeof window === "undefined" || typeof window.fbq !== "function") {
      return;
    }

    try {
      if (advancedMatching) {
        const matchData: Record<string, string> = {};
        if (advancedMatching.email) {
          matchData.em = advancedMatching.email.trim().toLowerCase();
        }
        if (advancedMatching.phone) {
          matchData.ph = advancedMatching.phone.replace(/\D/g, "");
        }
        if (advancedMatching.city) {
          matchData.ct = advancedMatching.city.trim().toLowerCase();
        }
        if (Object.keys(matchData).length > 0) {
          window.fbq("init", PIXEL_ID, matchData);
        }
      }

      window.fbq("track", "Lead", {
        content_name: "Eduvate Admissions Inquiry",
        content_category: "Study Abroad - Egypt",
      });
    } catch {
      // Pixel blocked or unavailable — tracking must never break the form.
    }
  },
};
